import Layout from "../include/layout";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import { Form, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { checkAuthenticate } from "../app/providers/authSlice";
import { useDispatch, useSelector } from "react-redux";

import Filarial from "../include/filarial";
import Joi from "joi-browser";

import Swal from "sweetalert2";
import EtablissementsService from "./EtablissementsService";

export default function EtablissementEdit() {
    const activeLink = "ETABLISSEMENTS"
    const [errors, setErrors] = useState({});
    const [id, setId]=useState("");
    const [raisonsocialeEtablissement, setRaisonsocialeEtablissement] = useState("");
    const [sigleEtablissement, setSigleEtablissement] = useState("");
    const [dirigeantEtablissement, setDirigeantEtablissement] = useState("");
    const [telephoneprimaireEtablissement, setTelephoneprimaireEtablissement] = useState("");
    const [telephonesecondaireEtablissement, setTelephonesecondaireEtablissement] = useState("");
    const [emailEtablissement, setEmailEtablissement] = useState("");
    const [emailsupportEtablissement, setEmailSupportEtablissement] = useState("");
    const [adresseEtablissement, setAdresseEtablissement] = useState("");
    const [siteWeb, setSiteWeb] = useState("");
    const [boitePostale, setBoitePostale] = useState("");
    const [emailnotificationEtablissement, setEmailnotificationEtablissement] = useState("");
    const [fondateurEtablissement, setFondateurEtablissement] = useState("");
    const [signatureEtablissement, setSignatureEtablissement] = useState("");
    const [logoEtablissement, setLogoEtablissement] = useState("");
    const [validationError, setValidationError] = useState({});
    const token = useSelector(state => state.auth.token)
    const navigate = useNavigate()
    const location = useLocation()

    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

    

    //####END GESTION DES REGLES DE VALIDATIONS ###########///
// Fonction appelée lorsqu'une nouvelle image est sélectionnée

const handleChangementLogo = (event) => {
    // Accéder au fichier sélectionné
    const logoEtablissement = event.target.files[0];
    // Stocker le fichier dans l'état
    setLogoEtablissement(logoEtablissement);
  };



   //get edit data
   const edit = async () => {
    await EtablissementsService.show(location.state.id, token).then((response) => {
        const data = response.data.data
        ///console.log(response.data.data)
        setId(data.id)
        setRaisonsocialeEtablissement(data.raisonsocialeEtablissement)
        setSigleEtablissement(data.sigleEtablissement)
        setDirigeantEtablissement(data.dirigeantEtablissement)
        setTelephoneprimaireEtablissement(data.telephoneprimaireEtablissement)
        setTelephonesecondaireEtablissement(data.telephonesecondaireEtablissement)
        setEmailEtablissement(data.emailEtablissement)
        setEmailSupportEtablissement(data.emailsupportEtablissement)
        setAdresseEtablissement(data.adresseEtablissement)
        setSiteWeb(data.siteWeb)
        setBoitePostale(data.boitePostale)
        setEmailnotificationEtablissement(data.emailnotificationEtablissement)
        setFondateurEtablissement(data.fondateurEtablissement)
        setSignatureEtablissement(data.signatureEtablissement)
        setLogoEtablissement(data.logoEtablissement)
    }).catch(error => {
        Swal.fire({
            icon: "error",
            text: error.message
        })
    });
}



const handleSubmitData = async (e) => {
       
    let id = location.state.id

  e.preventDefault();

  const formData = new FormData();
  formData.append("id",id)
  formData.append("raisonsocialeEtablissement", raisonsocialeEtablissement);
  formData.append("sigleEtablissement", sigleEtablissement);
  formData.append("dirigeantEtablissement", dirigeantEtablissement);
  formData.append("telephoneprimaireEtablissement", telephoneprimaireEtablissement);
  formData.append("telephonesecondaireEtablissement", telephonesecondaireEtablissement);
  formData.append("emailEtablissement", emailEtablissement);
  formData.append("emailsupportEtablissement", emailsupportEtablissement);
  formData.append("adresseEtablissement", adresseEtablissement);
  formData.append("siteWeb", siteWeb);
  formData.append("boitePostale", boitePostale);
  formData.append("emailnotificationEtablissement", emailnotificationEtablissement);
  formData.append("fondateurEtablissement", fondateurEtablissement);
  formData.append("signatureEtablissement", signatureEtablissement);
  formData.append("logoEtablissement", logoEtablissement);

  //console.log(formData);

  try {
    const response = await EtablissementsService.update(formData, token);

    if (response.data.status === 200) {
      //redirection sur index
      navigate(myroutes.etablissements_index);
      Swal.fire({
        icon: "success",
        text: response.data.message,
      });
    } else {
      Swal.fire({
        icon: "error",
        text: response.data.message,
        showConfirmButton: true,
        timer: 3000,
      });
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      text: error.message,
    });
  }
};


    useEffect(() => {
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
        edit();

    }, [dispatch]);

    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">

                <Filarial activeLink={activeLink} />

                <div className="row mb-4 mt-2">
                    {/* Bootstrap Validation */}
                    <div className="col-md">
                        <div className="card shadow-lg">
                            <h5 className="card-header">Modification </h5>
                            <Row>
                                {
                                    Object.keys(validationError).length > 0 && (
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="alert alert-danger">
                                                    <ul className="mb-0">
                                                        {
                                                            <li>{validationError}</li>
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </Row>

                            <div className="card-body">
                                <Form className="needs-validation" noValidate onSubmit={handleSubmitData}>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-raisonsocialeEtablissement">Nom Etablissement <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-raisonsocialeEtablissement" type="text" value={raisonsocialeEtablissement} onChange={(e) => setRaisonsocialeEtablissement(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} name="raisonsocialeEtablissement" />

                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-fondateurEtablissement">Fondateur<i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-fondateurEtablissement" type="text" value={fondateurEtablissement} onChange={(e) => setFondateurEtablissement(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} name="fondateurEtablissement" />
                       
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-dirigeantEtablissement">Dirigeant <i className="text-danger"></i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-dirigeantEtablissement" type="text" value={dirigeantEtablissement} onChange={(e) => setDirigeantEtablissement(e.target.value)}
                                                placeholder="" maxLength={100} name="dirigeantEtablissement" />
                                        </div>
                                    </div>

                                    <div className="row">
                                    <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-adresseEtablissement">Adresse Etablissement <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-adresseEtablissement" type="text" value={adresseEtablissement} onChange={(e) => setAdresseEtablissement(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} name="adresseEtablissement" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-telephoneprimaireEtablissement">Telephone primaire Etablissement <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-telephoneprimaireEtablissement" type="text" value={telephoneprimaireEtablissement} onChange={(e) => setTelephoneprimaireEtablissement(e.target.value)}
                                                placeholder="" required={true} maxLength={20} minLength={8} name="telephoneprimaireEtablissement" />                                            
                                          
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-telephonesecondaireEtablissement">Telephone secondaire Etablissement</Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-telephonesecondaireEtablissement" type="email" value={telephonesecondaireEtablissement} onChange={(e) => setTelephonesecondaireEtablissement(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} name="telephonesecondaireEtablissement" />
                                        </div>
                                    </div>

                                    <div className="row">
                                    <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-emailEtablissement">Email Etablissement <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-emailEtablissement" type="email" value={emailEtablissement} onChange={(e) => setEmailEtablissement(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} name="emailEtablissement" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-emailsupportEtablissement">Email support Etablissement</Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-emailsupportEtablissement" type="text" value={emailsupportEtablissement} onChange={(e) => setEmailSupportEtablissement(e.target.value)}
                                                placeholder="" maxLength={100} name="emailsupportEtablissement"  />     
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-emailnotificationEtablissement">Email Notification Etablissement </Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-emailnotificationEtablissement" type="text" value={emailnotificationEtablissement} onChange={(e) => setEmailnotificationEtablissement(e.target.value)}
                                                placeholder="" maxLength={100} name="emailnotificationEtablissement" />   
                                        </div>
                                    </div>
                                    <div className="row">

                                    <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-sigleEtablissement">Sigle Etablissement <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-sigleEtablissement" type="text" value={sigleEtablissement} onChange={(e) => setSigleEtablissement(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} name="sigleEtablissement" />
                       
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-siteWeb">Site Web <i className="text-danger"></i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-siteWeb" type="text" value={siteWeb} onChange={(e) => setSiteWeb(e.target.value)}
                                                placeholder="" maxLength={100} name="siteWeb"  />     
                                        </div>
                                       
                                    <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-boitePostale">Boite Postale <i className="text-danger"></i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-boitePostale" type="text" value={boitePostale} onChange={(e) => setBoitePostale(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} name="boitePostale" />
                                        </div>
                                    

                                    </div>
                                    <div className="row">
                                    <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-signatureEtablissement">Signature <i className="text-danger"></i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-signatureEtablissement" type="text" value={signatureEtablissement} onChange={(e) => setSignatureEtablissement(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} name="signatureEtablissement" />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-logoEtablissement">
                                            Logo Etablissement<i className="text-danger"></i>
                                            </Form.Label>
                                            <Form.Control
                                            className=""
                                            onChange={handleChangementLogo}
                                            aria-label=""
                                            required
                                            type="file"
                                            id="logoEtablissement"
                                            accept="image/jpeg, image/jpg, image/png, image/PNG, image/JPG, image/JPEG"
                                            />     
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <button type="submit" className="btn btn-primary">Enregistrer</button>
                                        </div>
                                    </div>
                                </Form>


                            </div>
                        </div>
                    </div>
                    {/* /Bootstrap Validation */}
                </div>

            </div>

        </Layout>
    )
}